import { ResolvedEntity } from '@frontend/common';

/** First entity name, plus ` +N` when more than one (list-card style). */
export const formatEntityNameWithExtra = (entities: ResolvedEntity[] | null | undefined): string => {
    const first = entities?.[0]?.name ?? '/';
    const extraCount = (entities?.length ?? 0) - 1;
    return extraCount > 0 ? `${first} +${extraCount}` : first;
};
